import React, {useState, useEffect} from 'react'
import './list.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {db} from '../../../firebase'
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { Link } from 'react-router-dom'
import defaultAvatar from '../../../assets/images/user.png';
// import StarIcon from '@mui/icons-material/Star';
// import StarBorderIcon from '@mui/icons-material/StarBorder';
// import MailOutlineIcon from '@mui/icons-material/MailOutline';

const List = () => {

  const [ subData, setSubData ] = useState([])

  const [ isLoading, setIsLoading ] = useState(true)



  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }

 
  useEffect(() => {
   
    
    //LISTEN REAL TIME
        const collectionRef = collection(db, "reviews")
        const querySub = query(collectionRef, orderBy("timeStamp", "desc"))
    
        const unsub = onSnapshot(querySub, (snapShot) => {
          let list = [];
          snapShot.docs.forEach((doc) => {
            list.push({ id: doc.id, ...doc.data(), timeStamp: doc.data().timeStamp.toDate()})
          })
          setSubData(list)
          setIsLoading(false)
        }, 
          (error) => {
            console.log(error)
          }
        );
    
        return () => {
          unsub();
        }
    
    //END LISTEN REAL TIME    
    
      },[])


  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        {/* <DataTable/> */}

        <div className='reviewTitle'>
          <h3 className='title'>Customers Reviews</h3>
        </div>

        <div className='reviewBody'>

        {isLoading ? <Spinner/> : 

          subData.map(row => {

          return (

          // <div className='reviewBody'>
              <div className='reviewSingle' key={row.id}>
                    <div className='reviewLeft'>

                      
                      <div className='reviewPhoto'>
                      <img
                          src={row.userImage ? row.userImage : defaultAvatar}
                          alt="avatar"
                          className="itemimg"
                          style={{width:80, height:80}}
                          resizeMode="cover"
                      />

                      </div>
              
                      <div className='reviewDetails'>
                      <div className='details'>
                        <div className="name">{row.outletname} {row.firstname}</div>
                        <div className="telephone">{row.region} {row.lastname}</div>
                        <div className="email">Overall Rating</div>
                      </div>
                      <Link to={`/reviews/${row.id}`} key={row.id} className='reviewLink'>View Customers Reviews</Link>
                      </div>
                       
                    </div>
                   
                  
              </div>
          // </div>
          
          )

        })

        }

        </div>

      </div>
    </div>
  )
}

export default List